import {
    useState,
    useEffect
} from "react";

import {
    Button
} from "react-bootstrap";

import "./App.css";

export default function TrialModuleRow(props) {
    const [rowKey, setRowKey] = useState("");
    const [rowValue, setRowValue] = useState("");

    const onTextChange = (e, txtField) => {
        const val = e.target.value;

        if (txtField === "KEY") {
            setRowKey(val);
        } else if (txtField === "VALUE") {
            setRowValue(val);
        }

        props.onChange(val, txtField, props.keyIndex);
    };

    const onDelete = () => {
        props.onDelete(props.keyIndex);
    };

    useEffect(() => {
        const {
            key,
            value
        } = props.initialData;

        setRowKey(key);
        setRowValue(value);
    }, []);

    return (
        <tr className="tbody-row">
            <td className="tbody-cell"><input type="text" value={ rowKey } onChange={(e) => { onTextChange(e, "KEY") }} /></td>
            <td className="tbody-cell"><input type="text" value={ rowValue } onChange={(e) => { onTextChange(e, "VALUE") }} /></td>
            <td className="tbody-cell tbody-cell-centered">
                <Button variant="danger" onClick={ onDelete }><img src="img/remove_circle_white_36dp.svg" /></Button>
            </td>
        </tr>
    );
}